'use client';

import { useMergeRefs } from '@floating-ui/react';
import { IconMoreFilled } from '@zillow/constellation-icons/react/filled/icon-more-filled';
import { forwardRef, useContext } from 'react';

import { IconButton } from '../icon-button';
import { Slot } from '../slot';
import { DropdownRootContext } from './context/dropdown-root.context';
import type { DropdownTriggerPropsInterface } from './types/dropdown-trigger.types';

/**
 * @since 10.0.0
 */
export const DropdownTrigger = forwardRef<HTMLButtonElement, DropdownTriggerPropsInterface>(
  (props: DropdownTriggerPropsInterface, forwardedRef) => {
    const {
      children = <IconButton icon={<IconMoreFilled />} emphasis="bare" tone="brand" title="More" />,
      ...rest
    } = props;
    const { dropdown } = useContext(DropdownRootContext);
    const mergedRefs = useMergeRefs([dropdown.refs.setReference, forwardedRef]);

    return (
      <Slot
        ref={mergedRefs}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Trigger"
        {...dropdown.getReferenceProps(rest)}
      >
        {children}
      </Slot>
    );
  },
);

DropdownTrigger.displayName = 'Dropdown.Trigger';
